<template>
  <div id="centerLeft1">
    <div class="centerLeft1Title">
      行业类型统计
    </div>
    <div class="centerLeft1Box">
      <!-- <div class="centerLeft1BoxTop">
        <div class="selectTitle">
          行业类型
        </div>
        <el-select style="width: 132px;height: 30px;margin-right: 34px;" class="select" v-model="value"
          placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <div class="selectTitle">
          岗位类型
        </div>
        <el-select style="width: 132px;height: 30px;" class="select" v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div> -->

      <!-- <div class="industryType">
        <div style="margin-right: 37px;" :class="industryType == 0 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(0)">
          就业行业
        </div>
        <div style="margin-right: 24px;" :class="industryType == 1 ? 'actionAndustryType' : 'industryTypeItem'"
          @click="clickAction(1)">
          招聘行业
        </div>
      </div> -->
      <div id="chartInstance" ref="chartInstance">

      </div>

    </div>
  </div>
</template>

<script>
import { getPositionBarChatApi } from '@/utils/api'

export default {
  data() {
    return {
      value: '',
      industryType: 0,
      xAxisData: [],
      employmentCount: [],
      recruitCount: [],
    }
  },
  components: {
  },
  mounted() {
    this.getPositionBarChat()
  },
  methods: {

    async getPositionBarChat(data) {
      await getPositionBarChatApi({
        ...data,
        size: 6
      }).then(res => {
        this.xAxisData = res.data.data.name
        this.employmentCount = res.data.data.employmentCount
        this.recruitCount = res.data.data.recruitCount
        // this.toolList = res.data.data.list
        this.chartInstanceInit()
      })
    },

    chartInstanceInit() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        color: '#7dedfc',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            axisPointer: {
              type: 'shadow'
            },
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          // x: 'right',
          right:30,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: '#ffffff'
          }
        },

        grid: {
          x: 0,
          y: 30,
          x2: 0,
          y2: 0,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#3b3b3c',
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#3b3b3c',
                width: 1,
                type: 'solid'
              }
            },
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: '#fff'
            },
            data: this.xAxisData
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#8A8C91'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#232F3A',
                width: 2,
                type: 'dotted'
              }
            },
            nameTextStyle: {
              rich: {
                legend: {
                  width: 12,
                  height: 4,
                  backgroundColor: 'red'
                },
                value: {
                  color: '#FF8C00'
                }
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            name: '就业行业',
            barWidth: 8,
            data: this.employmentCount,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#16D4B2'
              },
              {
                offset: 1,
                color: '#0E84F2'
              }]),
            },
          },
          {
            type: 'bar',
            name: '招聘行业',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#25DC1C'
              },
              {
                offset: 1,
                color: '#40FF40'
              }]),
            },
            barWidth: 8,
            data: this.recruitCount,
          },
        ]
      }
      // console.log(initOption);
      chartInstance.setOption(initOption)
    },

    //切换行业类型
    clickAction(e) {
      this.industryType = e
    },
  }
}
</script>

<style lang="scss" scoped>
.select {

  ::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
    border: none;
    border-radius: 4px;
    background: linear-gradient(90deg, #008490 0%, #011735 52%, #00808C 100%);
  }

  ::v-deep .el-input__icon {
    line-height: 30px;
  }
}



#centerLeft1 {
  width: 535px;
  // height: 379px;
  margin-bottom: 25px;

  .centerLeft1Title {
    font-weight: bold;
    font-size: 28px;
    color: #0EE1F4;
    background: linear-gradient(179deg, #0EE1F4 0%, #0096FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-left: 120px;
    line-height: 1;
  }

  .centerLeft1Box {
    box-sizing: border-box;
    padding: 40px 25px 0 25px;
    width: 531px;
    height: 285px;
    // background: rgba(14, 225, 244, 0.1);
    // box-shadow: 0px 0px 43px 0px rgba(0, 234, 255, 0.43);
    background-image: url('../assets/left1Bg.png');
    background-size: 100% 100%;
  }

  .centerLeft1BoxTop {
    display: flex;
    align-items: center;
    height: 30px;
    margin-bottom: 14px;
  }

  .selectTitle {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-right: 14px
  }

  .industryType {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 99999;
  }

  .industryTypeItem {
    width: 86px;
    height: 30px;
    background: linear-gradient(90deg, #008490 0%, #011735 52%, #00808C 100%);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #0EE1F4;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }

  .actionAndustryType {
    width: 86px;
    height: 30px;
    background: linear-gradient(90deg, #008490 0%, #011735 52%, #00808C 100%);
    border-radius: 4px;
    border: 1px solid;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
}

#chartInstance {
  width: 500px;
  height: 210px;
  // margin-left: -60px;
  // margin-top: -20px;
}
</style>
